/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_rn_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free Roman numeral converter. Convert numbers to Roman numerals and Roman numerals back to numbers (1–3999). Runs in your browser.`)
};

const es_rn_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertidor gratuito de numerales romanos. Convierte números a numerales romanos y numerales romanos a números (1–3999). Se ejecuta en tu navegador.`)
};

const de_rn_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Umrechner für römische Zahlen. Wandeln Sie Zahlen in römische Zahlen um und römische Zahlen zurück in Zahlen (1–3999). Läuft direkt in Ihrem Browser.`)
};

const nl_rn_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis converter voor Romeinse getallen. Converteer getallen naar Romeinse getallen en omgekeerd (1–3999). Draait in uw browser.`)
};

const fr_rn_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertisseur gratuit de chiffres romains. Convertissez les nombres en chiffres romains et les chiffres romains en nombres (1–3999). Fonctionne dans votre navigateur.`)
};

const it_rn_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertitore gratuito di numerali romani. Converti i numeri in numerali romani e i numerali romani in numeri (1–3999). Viene eseguito nel tuo browser.`)
};

const pt_br2_rn_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversor gratuito de numerais romanos. Converta números em numerais romanos e numerais romanos em números (1–3999). Funciona no seu navegador.`)
};

const pt_rn_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversor gratuito de numerais romanos. Converta números em numerais romanos e numerais romanos de volta para números (1–3999). Funciona no seu navegador.`)
};

const ja_rn_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料のローマ数字コンバーター。数字をローマ数字に変換し、ローマ数字を数字に変換します(1〜3999)。ブラウザで実行されます。`)
};

const zh_rn_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费的罗马数字转换器。将数字转换为罗马数字，也可以将罗马数字转换回数字（1–3999）。在浏览器中运行。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const rn_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.rn_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("rn_tool_description", locale)
	if (locale === "en") return en_rn_tool_description(inputs)
	if (locale === "es") return es_rn_tool_description(inputs)
	if (locale === "de") return de_rn_tool_description(inputs)
	if (locale === "nl") return nl_rn_tool_description(inputs)
	if (locale === "fr") return fr_rn_tool_description(inputs)
	if (locale === "it") return it_rn_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_rn_tool_description(inputs)
	if (locale === "pt") return pt_rn_tool_description(inputs)
	if (locale === "ja") return ja_rn_tool_description(inputs)
	return zh_rn_tool_description(inputs)
};